import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * ListWrapper Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Component used for item
     */
    @Prop() component!: object;

    /**
     * Data to pass to component
     */
    @Prop() items!: Array<object>;

    /**
     * Endpoint to fetch data
     */
    @Prop() endpoint!: {[k: string]: any};

    /**
     * Limit of the Items to show
     */
    @Prop({ default: 4 }) limit!: string | number;

    /**
     * Show item in slideshow
     */
    @Prop({ type: Boolean }) slide!: boolean;

    /**
     * Loading State
     */
    @Prop({ type: Boolean }) loading!: boolean;

    /**
     * Loading State using _$wait_ service
     */
    @Prop({ type: String }) loadingOn!: string;

    /**
     * Loading has raised style
     */
    @Prop({ type: Boolean }) raisedLoading!: boolean;
}
